import {
  getList,
  getObject,
} from "@surya-digital/leo-ts-types";
import { OpenEndedResultV1, OpenEndedResultV1DTO } from "./openEndedResultV1";
import { GridRowDetailsV1, GridRowDetailsV1DTO } from "./gridRowDetailsV1";
import { Code, CodeDTO } from "../types/code";

export interface GridOpenEndedResultWithRowDetailsV1DTO {
  openEndedResults: OpenEndedResultV1DTO[];
  gridRowDetails: GridRowDetailsV1DTO;
  fieldCode: CodeDTO;
}

export class GridOpenEndedResultWithRowDetailsV1 {
  readonly isGridOpenEndedResultWithRowDetailsV1GridOpenEndedResultWithRowDetailsV1: boolean = true;

  readonly openEndedResults: OpenEndedResultV1[];
  readonly gridRowDetails: GridRowDetailsV1;
  readonly fieldCode: Code;


  constructor(
  openEndedResults: OpenEndedResultV1[], 
  gridRowDetails: GridRowDetailsV1, 
  fieldCode: Code
  ) {
    this.openEndedResults = openEndedResults;
    this.gridRowDetails = gridRowDetails;
    this.fieldCode = fieldCode;
  }

  static fromDTO(dto: GridOpenEndedResultWithRowDetailsV1DTO): GridOpenEndedResultWithRowDetailsV1 {
    const openEndedResults = getList<OpenEndedResultV1DTO, OpenEndedResultV1>(
      dto,
      "openEndedResults",
      OpenEndedResultV1.fromDTO,
      InvalidGridOpenEndedResultWithRowDetailsV1OpenEndedResultsError
    );
    const gridRowDetails = GridRowDetailsV1.fromDTO(getObject(dto, "gridRowDetails", InvalidGridOpenEndedResultWithRowDetailsV1GridRowDetailsError));
    const fieldCode = Code.fromDTO(getObject(dto, "fieldCode", InvalidGridOpenEndedResultWithRowDetailsV1FieldCodeError));
    return new GridOpenEndedResultWithRowDetailsV1(
      openEndedResults,
      gridRowDetails,
      fieldCode
    );
  }

  toDTO(): GridOpenEndedResultWithRowDetailsV1DTO {
    const dto: GridOpenEndedResultWithRowDetailsV1DTO = {
        openEndedResults: this.openEndedResults.map((e: OpenEndedResultV1) => { return e.toDTO() }),
        gridRowDetails: this.gridRowDetails.toDTO(),
        fieldCode: this.fieldCode.toDTO()
    };
    return dto;
  }
  }

GridOpenEndedResultWithRowDetailsV1.prototype.toString = function toString(): string {
  return `GridOpenEndedResultWithRowDetailsV1(openEndedResults='${this.openEndedResults}',gridRowDetails='${this.gridRowDetails}',fieldCode='${this.fieldCode}')`;
};

export class InvalidGridOpenEndedResultWithRowDetailsV1Error extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridOpenEndedResultWithRowDetailsV1Error";
  }
}
export class InvalidGridOpenEndedResultWithRowDetailsV1OpenEndedResultsError extends InvalidGridOpenEndedResultWithRowDetailsV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridOpenEndedResultWithRowDetailsV1OpenEndedResultsError";
  }
}

export class InvalidGridOpenEndedResultWithRowDetailsV1GridRowDetailsError extends InvalidGridOpenEndedResultWithRowDetailsV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridOpenEndedResultWithRowDetailsV1GridRowDetailsError";
  }
}

export class InvalidGridOpenEndedResultWithRowDetailsV1FieldCodeError extends InvalidGridOpenEndedResultWithRowDetailsV1Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidGridOpenEndedResultWithRowDetailsV1FieldCodeError";
  }
}
